import type { GtmBrainDoc } from "../api/GtmApi";

export type ObjectionListItem = {
  key: string;
  index: number;
  doc: GtmBrainDoc;
  label: string;
  filled: number;
  total: number;
  isNew: boolean;
};

function hasText(value?: string | null): boolean {
  return !!value && value.trim().length > 0;
}

export function objectionFill(doc: GtmBrainDoc): { filled: number; total: number } {
  const checks = [hasText(doc.objection), hasText(doc.response)];
  return { filled: checks.filter(Boolean).length, total: checks.length };
}

export function objectionLabel(doc: GtmBrainDoc, _index: number): string {
  const objection = (doc.objection || "").trim();
  if (objection) return objection.length > 72 ? `${objection.slice(0, 69)}…` : objection;
  const name = (doc.name || "").trim();
  if (name) return name;
  return "New objection";
}

/** Stable key — keep in sync with brainToFlow docLeaves ids. */
export function objectionKey(doc: GtmBrainDoc, objectionIndex: number): string {
  return doc.id || `doc-objection-${objectionIndex}`;
}

export function listObjections(docs: GtmBrainDoc[]): ObjectionListItem[] {
  const only = docs
    .map((doc, index) => ({ doc, index }))
    .filter(({ doc }) => doc.docType === "objection");
  return only.map(({ doc, index }, objectionIndex) => {
    const fill = objectionFill(doc);
    const label = objectionLabel(doc, objectionIndex);
    return {
      key: objectionKey(doc, objectionIndex),
      index,
      doc,
      label,
      filled: fill.filled,
      total: fill.total,
      isNew: label === "New objection" && fill.filled === 0,
    };
  });
}

export function objectionSections(
  doc: GtmBrainDoc
): Array<{ id: "objection" | "response"; label: string; body: string }> {
  return [
    { id: "objection", label: "Objection", body: doc.objection || "" },
    { id: "response", label: "Response", body: doc.response || "" },
  ];
}
